import React,{ useState, useRef } from 'react'
import styles from './variants.scss'
import { connect } from 'react-redux'
import SliderWrapper from 'jd-library/SliderWrapper'
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel'
import ItemExpiry from '../../add-edit-item/item-expiry/ItemExpiry.js';
import SwitchButtonWithMovingInput from '../../../common/Switch-Button-with-Moving-Input/SwitchButtonWithMovingInput';
import { scanBarcode } from '../appUtils/AppUtils'
import { generateBarcode, Regex } from '../../../utills'
import { showMoreDetailsSlider } from '../../../actions/variants'
import toastMessageActions from 'jd-library/toastMessageActions'
import ViewImage from '../../../common/ViewImage/ViewImage'
import useOnScroll from 'jd-library/useOnScroll';
import { getImagePath } from '../../../common/fileUtills'
import { updateVideoInLibrary } from '../../../actions/videoLibrary';
import FormSwitch from 'jd-library/FormSwitch';
import { onScannerDetectedCB, onScannerFailedCB } from '../scanner/utils';
import { toggleBarcodeScannerSecondary } from '../../../actions/barcodeScanner';

const VariantMoreDetails = (props) => {

    const [productData,setProductData] = useState(JSON.parse(JSON.stringify(props.productData)))
    const [scrolled, setScroll] = useState(false);
    const [scrollEl, setScrollEl] = useState(null);
    const [positionUnset, setPositionUnset] = useState(false)
    const isApp = props.deviceData.isAndroidApp || props.deviceData.isIphoneApp || props.deviceData.isIpadApp || props.deviceData.isMobile;
    const expiryData = useRef({
        errors: {},
        warnings: {}
    });
    let validationObj = useRef(null);
    const regexObj = {
        money: Regex.priceRegex,
        quantity: /^\d{0,6}$/,
    }
    const showWarning = (productData.sp && productData.mrp && (Number(productData.sp) > Number(productData.mrp)));
    const moreInputs = [
        {
            key: 'quantity',
            label: 'Quantity',
            className: 'single-width',
            type: 'tel',
            regex: 'quantity',
            errorMessage: productData.errors['quantity'],
            errClass: productData.errors['quantity'] && productData.errors['mrp']?styles['single-err']:''
        },
        {
            key: 'mrp',
            label: 'MRP',
            className: 'single-width',
            type: 'tel',
            regex: 'money',
            errorMessage: productData.errors['mrp'],
            errClass: styles['single-err']
        },
        {
            key: 'sp',
            label: 'Selling Price',
            className: 'single-width',
            type: 'tel',
            regex: 'money',
            errorMessage: showWarning ? 'Higher than MRP' : productData.errors['sp']?productData.errors['sp']:'',
            errClass: styles['sp-error']
        },
        (() => {
            if(props.session.viaOmni){
                return ({
                    key: 'cp',
                    label: 'Cost Price',
                    className: 'single-width',
                    type: 'tel',
                    regex: 'money'
                })
            }            
        })(),
        {
            key: 'barcode',
            label: 'Barcode',
            className: props.session.viaOmni ? 'double-width' : 'triple-width',
            inputGroupProps: {
                rightSection: () => {
                    return (
                        <div className={styles["barcode-icons"]}>
                            {/* {(!productData.barcode) && <i onClick={fillBarcode} className="icon-Generate"></i>} */}
                            {(isApp || props.session.viaOmni) && !productData.barcode && <i onClick={fillBarcode} className="icon-barcode"></i>}
                        </div>
                    );
                }
            }
        },
        (() => {
            if(props.session.viaOmni){
                return ({
                    key: 'batch',
                    label: 'Batch / Lot Number',
                    className: 'triple-width'
                })
            }            
        })(),
    ].filter(field=>!!field)

    const autoMaintainProps = {
        level: {
            type: "level",
            label: "Auto Maintain Re-order Level / Point",
            content: "Reorder Level / Point  is the minimum amount of an item that you hold, at which you would place a new purchase order.",
            inputProps: {
                inputLabel: "Re-order Level / Point",
                toggle: productData?.isAutoReorderLevel || false,
                value: productData?.reorderLevel || '',
                onChange: (type, value, toggleInput) => {
                    setProductData({...productData, isAutoReorderLevel: toggleInput,reorderLevel: value});
                }
            },
            fixToTop: true
        },
        quantity: {
            type: "quantity",
            label: "Auto Maintain Re-order Quantity",
            content: "Reorder Quantity is the number of quantity needed to be purchased from the supplier.",
            inputProps: {
                inputLabel: "Re-order Quantity",
                toggle: productData?.isAutoReorderQuantity || false,
                value: productData?.reorderQuantity || '',
                onChange: (type, value, toggleInput) => {
                    setProductData({...productData, isAutoReorderQuantity: toggleInput, reorderQuantity: value});
                }
            },
            fixToTop: true
        }
    };

    const updateProductData = (key,value) => {
        setProductData({...productData, [key]: value});
    }

    const scanBarcodeFunc = (event) => {
        if(window.JdLiteInterface && props.isSourceJustdial){
            //For App
            scanBarcode({
                callback: data => {
                    console.log('barcodeData: ',data);
                    updateProductData('barcode',data)
                }
            });
        }else if (navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function') {
            props.toggleBarcodeScannerSecondary({
                showScannerSecond: true,
                onDetectedCB: (barcode) => updateProductData('barcode',barcode),
                onFailedCB: onScannerFailedCB
            })
        } else {
            console.log("getUserMedia Not Supported");
        }
    };

    const fillBarcode = () => {
        if(isApp) {
            scanBarcodeFunc();
            return;
        }
        generateBarcode(1).then((res) => {
            updateProductData('barcode',res.data[0])
        }).catch((error) => {
        })
    }

    const validation = () => {
        let errorObj = {},errorMsg;
        if(!(productData['imageUrlArr'].length || !productData.hasOwnProperty('imageUrlArr'))){
            errorObj['imageUrlArr'] = true;
            errorMsg = errorMsg?errorMsg:'Please upload product image';
        }
        if(!productData.quantity){
            errorObj['quantity'] = 'Please Enter Qty';
            errorMsg = errorMsg?errorMsg:'Please Enter Quantity';
        }
		if(productData.quantity == "0"){
			errorObj['quantity'] = "Qty can't be Zero";
			errorMsg = errorMsg?errorMsg:"Qty can't be Zero";
		}
		if(Number(productData.sp) > Number(productData.mrp) && !errors['quantity']){
			errorObj['sp'] = mrp?'Higher than MRP':true;
            errorMsg = errorMsg?errorMsg:'Selling Price cannot be greater than MRP';
		}
        if(!productData.mrp) {
            if(errorObj['quantity'] && !productData.quantity) {
                errorObj['quantity'] = 'Please Enter Qty	 & Price';
                errorObj['mrp'] = true;
                errorMsg = errorMsg && errorObj['imageUrlArr']?errorMsg:'Please Enter Quantity & Price';
            }else if(productData.quantity && productData.quantity != "0") {
                errorObj['mrp'] = 'Please Enter MRP';
                errorMsg = errorMsg?errorMsg:'Please Enter MRP';
            }else if(productData.quantity == '0'){
				errorObj['mrp'] = true;
			}
        }
		if(productData.mrp == '0'){
			errorObj['mrp'] = errorMsg && errorObj['quantity']?true:"MRP can't be Zero";
			errorMsg = errorMsg?errorMsg:"MRP can't be Zero";
		}
		if(productData.mrp == '1'){
			errorObj['mrp'] = errorMsg && errorObj['quantity']?true:"Invalid Value";
			errorMsg = errorMsg?errorMsg:"Invalid Value";
		}
        if(!productData.sp) {
            errorObj['sp'] = errorMsg?true:'Please Enter SP';
            errorMsg = errorMsg?errorMsg:'Please Enter SP';
        }
		if(productData.sp == '0'){
			errorObj['sp'] = errorMsg && (errorObj['quantity'] || errorObj['mrp'])?true:"SP can't be Zero";
			errorMsg = errorMsg?errorMsg:"SP can't be Zero";	
		}
		if(productData.sp == '1'){
			errorObj['sp'] = errorMsg && (errorObj['quantity'] || errorObj['mrp'])?true:"Invalid Value";
			errorMsg = errorMsg?errorMsg:"Invalid Value";	
		}
        if(errorMsg){
            props.showToastMessage({
                showToastMessage: true,
                message: errorMsg,
                duration: 5000,
                type: 'info'
            })
            setProductData({...productData, errors: {...productData.errors, ...errorObj}})
            return false;
        }else{
            return true;
        }
    }

    const uploadImage = (res) => {
        //#TO_DO - Make Single Function
        let temp = {...productData}
        let saveData = true;
        if(res.forVideo){
            if(res.initialReq){
                temp.videoUrlArr.push(res.imageUrl);
                props.updateVideoInLibrary({...res.imageUrl, isVariantProduct: true}) //Add the Video to the Library
            }else{
                if(!res.imageUrl.videoId){
                    //Generate the Video ID for uploaded videos
                    saveData = false;
                    props.updateVideoInLibrary({...res.imageUrl, variantId: "", isVariantProduct: true, cb: (id)=>{
                        temp.videoUrlArr[0] = ({...res.imageUrl, uploaded: true, videoId: id});
                        setProductData(temp);
                    }})
                }else{
                    temp.videoUrlArr[0] = ({...res.imageUrl, uploaded: true})
                }
            }
        }else{
            if(res.createdfrom == 'url'){
                res.imageUrl = {
                    uploaded: true,
                    imgURL: res.imgURL,
                    actualPath: getImagePath(res.imgURL)
                }
                temp.imageUrlArr.push(res.imageUrl)
            }else if(res.createdfrom == 'photoGallery' || res.createdfrom == 'copyImages'){
                temp.imageUrlArr.push(...res.imageUrlArr)
            }else if(res.imageUrl.uploaded){
                for(let i=0;i<temp.imageUrlArr.length;i++){
                    if(temp.imageUrlArr[i].imgIndex == res.imgIndex){
                        temp.imageUrlArr[i] = res.imageUrl
                    }
                }
            }else{
                temp.imageUrlArr.push(res.imageUrl)
            }
        }
        saveData && setProductData(temp);
        return temp;
    }
    useOnScroll({
        callback : (e,scrollObj) => {
          if(scrollObj.currScroll.scrollTop){
            setScroll(true);
          }else{
             setScroll(false)
          }
        },
        element : !scrollEl ? null : scrollEl,
        deps: [scrollEl]
    })
    return(
        <SliderWrapper
            header={{heading: (
                    <div>
                        Add More Details
                        <div>{props.titleStr}</div>
                    </div>
                ),
                raised: scrolled
            }}
            onHidden={()=>{
                props.showMoreDetailsSlider({
                    show: false
                })
            }}
            footer={{
                btnProps: [{
                    children: 'Save',
                    clickHandler: () => {
                        if(props.session.viaOmni){
                            if(Number(productData.quantity) > 100) {
                                var errorObj = {quantity: 'Cannot be More than 100'};
                                props.showToastMessage({
                                    showToastMessage: true,
                                    message: 'Qty Cannot be More than 100',
                                    duration: 5000,
                                    type: 'info'
                                })
                                setProductData({...productData, errors: {...productData.errors, ...errorObj}});
                                return;
                            }
                            if(props.permissions?.packagePermissionData?.isMaintainExpiry) {
                                const {isError = false} = validationObj.current.validateDates() || {};
                                if(isError) {
                                    return;
                                }
                            }
                            props.onSave(productData,props.index);
                            window.history.back();
                            return
                        }
                        if(validation()){
                            props.onSave(productData,props.index);
                            window.history.back();
                        }
                    }
                }],
                className: `${isApp && positionUnset ? "btnFixBottom" : ""}`
            }}
            updateScrollContRef={(scrollref) => {
                setScrollEl(scrollref)
            }}
            slider={{className: (styles['variant-slider'] + ' ' + styles['more-details-slider'])}}
        >
            <div className={styles['slider-body']}>
                <div className='image'>
                    <ViewImage
                        canUploadImage={true}
                        imageUrlArr={[...productData.imageUrlArr, ...productData.videoUrlArr]}
                        videoUrlIds={[...productData.videoUrlArr]}
                        updateProductImage={(res)=>uploadImage(res)}
                        deleteProductImage={(res)=>{
                            updateProductData('imageUrlArr',res.imageUrlArr.filter(obj=>!obj.isVideo))
                        }}
                        deleteProductVideo={(res)=>updateProductData('videoUrlArr',[])}
                        hideAddVideo={productData.videoUrlArr.length > 0}
                        session={props.session}
                        showToastMessage={props.showToastMessage}
                        noImgLabel='Add Image'
                        productId={"ADD_PRODUCT"}
                        isMobile={props.deviceData.isMobile}
                        uploadOptionProps={{    
                            vendorSubMenu: true,
                            isVariant: true,
                            variantIndex: props.index,
                            onFileUpload: (res) => uploadImage(res),
                            variantProducts: props.allProductData
                        }}
                        imgUploadUrl={'/marketplace/products/ajax/uploadProductImageForB2B.service?supplierId='+props.permissions.supplierId}
                        errorMessage={productData.errors['imageUrlArr']}
                    />
                </div>
                <div className={styles['multi-input-section']}>
                    {moreInputs.map((input)=>{
                        return(
                            <InputWithMovingLabel 
                                input={{
                                    value: productData[input.key] || "",
                                    onChange: e => {
                                        if(!input.regex || regexObj[input.regex].test(e.target.value)){
                                            updateProductData(input.key,e.target.value);
                                        }
                                    },
                                    onFocus: e => {
                                        setProductData({...productData, errors: {...productData.errors, [input.key]: ''}})
                                        setPositionUnset(true)
                                    },
                                    onBlur: e => {
                                        setPositionUnset(false)
                                    },
                                    type: input.type ? input.type : 'text'
                                }}
                                label={input.label}
                                warning={input.warning}
                                errorMessage={input.errorMessage}
                                errClass={input.errClass}
                                inputGroupProps={input.inputGroupProps}
                                holderClass={input.className}
                                // {...(props.deviceData.isMobile ? {className: input.className} : {holderClass: input.className})}
                            />
                        )
                    })}
                </div>
                {props.session.viaOmni && props.permissions?.packagePermissionData?.isMaintainExpiry ?
                        <ItemExpiry
                            itemInfo={{
                                manufacturingDate: productData['manufacturingDate'],
                                expiryDate: productData['expiryDate'],
                                expiryBy: productData['expiryBy'],
                                bestBefore: productData['bestBefore'],
                                bestBeforeUnit: productData['bestBeforeUnit']
                            }}
                            warnings={productData.warnings}
                            errors={productData.errors}
                            updateItemInfo={expiryData=>{
                                // console.log("updateItemInfo")
                                setProductData({ ...productData, ...expiryData });
                            }}
                            updateInfoAndErrors={(key, value, err, warn) => {
                                if (value != null)
                                    expiryData.current[key] = value;
                                if (err != null)
                                    expiryData.current['errors'][key] = err
                                if (warn != null)
                                    expiryData.current['warnings'][key] = warn
                                setProductData({ ...productData, ...expiryData.current });
                            }}
                            openTop={true}
                            updateFunc={(ref) => validationObj.current = ref}
                        />  : <></>
                }
                <div className={styles['show-on-website']}>
                    Show on Website
                    <FormSwitch
                        checked={productData.showOnWebsite}
                        onClick={e => {
                            setProductData({...productData, showOnWebsite: e.target.checked}, props.index)
                        }}
                        showToggleStatus={false}
                        className={styles['switch-button']}
                    />
                </div>
                
                {props.viaOmni && !props.isEdit ? <div className={`${styles['auto-maintain-reorder']} ${styles['auto-maintain-holder']}`}>
                    <SwitchButtonWithMovingInput {...autoMaintainProps.level} />
                    <SwitchButtonWithMovingInput {...autoMaintainProps.quantity} />
                </div> : null}
            </div>
        </SliderWrapper>
    )
}

const mapStateToProps = (state,props) => {
    return{
        ...props,
        deviceData: state.library.deviceData,
        productData: state.variants.moreDetailsSlider.productData,
        allProductData: state.variants.moreDetailsSlider.allProductData,
        titleStr: state.variants.moreDetailsSlider.titleStr,
        index: state.variants.moreDetailsSlider.index,
        onSave: state.variants.moreDetailsSlider.onSave,
        deviceData: state.deviceData,
        session: state.session,
        permissions: state.permissions,
        isEdit: state.items.itemInfo.isEdit,
		isSourceJustdial: state.session.isJdSourceAndroid || state.session.isJdSourceIOS,
        viaOmni: state.session?.viaOmni || false
    }
}

export default connect(mapStateToProps,{
    showMoreDetailsSlider,
    updateVideoInLibrary,
    showToastMessage: toastMessageActions.showMessage,
    toggleBarcodeScannerSecondary
})(VariantMoreDetails)